import React, { useContext } from "react";
import Mergenew from "../pages/Mergenew";
import ViewForceSupUser from "./ViewForceSupUser";
import { AuthContext } from "../context/AuthContext";
import { hasRole } from "../utils/guestUser";

function ViewForceMain() {
  const { userData } = useContext(AuthContext);
  const userRole = userData?.[0]?.DR_Name;

  let layoutComponent;
  if (
    hasRole(userRole, "Manager") ||
    hasRole(userRole, "ProcessLead") ||
    hasRole(userRole, "DepartmentLead")
  ) {
    layoutComponent = <ViewForceSupUser />;
  } else if (hasRole(userRole, "Admin") || hasRole(userRole, "Super Admin") || hasRole(userRole, "Managing Director")) {
    layoutComponent = <Mergenew />;
  } else if (hasRole(userRole, "Consultant") || hasRole(userRole, "consultant")) {
    layoutComponent = <Mergenew />;
  } else {
    // Default fallback
    layoutComponent = <Mergenew />;
  }

  return (
    <>
      {layoutComponent}
    </>
  );
}

export default ViewForceMain;
